import { nameof } from "../../../../utils/nameof";
import {
  DescribeMissingField,
  OWN_CLAIMS_ENTRIES_FIELD,
  entriesMissing,
  itemField,
} from "../../utils/missingFields.utils";
import { AssetOwnClaimsFormValues } from "./OwnClaimsView.types";

const HAS_OWN_CLAIMS = nameof<AssetOwnClaimsFormValues>("hasOwnClaims");
const OWN_CLAIMS = nameof<AssetOwnClaimsFormValues>("ownClaims");

export const describeMissingOwnClaimField: DescribeMissingField<AssetOwnClaimsFormValues> = (missing, values, t) => {
  if (missing.field === OWN_CLAIMS_ENTRIES_FIELD) {
    return entriesMissing(HAS_OWN_CLAIMS, t);
  }
  if (missing.itemId === null) {
    return { path: missing.field };
  }
  return itemField(OWN_CLAIMS, values.ownClaims, missing);
};
